import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import "./ApplicationManagement.css";
import NavigationBar from "../../Components/NavigationBar";

export default function FinalApplications() {
  const [showModal, setShowModal] = useState(false);
  const [applications, setApplications] = useState([]);
  const [currentAppID, setCurrentAppID] = useState(null);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;

  // Fetch applications from the backend
  useEffect(() => {
    fetch(`${API_BASE_URL}/getfinalApplications`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched Data:", data); // Log the API response
        if (Array.isArray(data)) {
          setApplications(data);
        } else {
          console.error("API did not return an array:", data);
        }
      })
      .catch((error) => console.error("Error fetching applications:", error));
  }, []);

  // // Open modal to choose shortlist/rejection
  // const handleOpenModal = (app_ID) => {
  //   setCurrentAppID(app_ID);
  //   setShowModal(true);
  // };

  
  return (
    <div>
      <NavigationBar />
      <h1 className="page-name">Finalized Applications</h1>
      <Table className
        striped
        bordered
        hover
        style={{
          marginTop: "20px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        <thead>
          <tr>
            <th>Applicant Name</th>
            <th>Application Id</th>
            <th>Award Type</th>
            <th>Submitted Date</th>
            <th>Status</th>
            <th>Application</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {/* Display applications */}
          {Array.isArray(applications) &&
            applications.map((app) => (
              <tr key={app.Application_Id}>
                <td>{app.Name}</td>
                <td>{app.Application_Id}</td>
                <td>{app.Award_Type}</td>
                <td>{app.SubmittedDate}</td>
                <td>{app.Status}</td>
                <td>
                  <button
                    className="View_Button"
                    onClick={() => {
                      const formattedAwardType = app.Award_Type.replace(
                        /\s+/g,
                        "_"
                      );
                      const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
                      const fileUrl = `${FILE_BASE_URL}/api/Uploads/ApplicationForms/${fileName}`;
                      window.open(fileUrl, "_blank");
                    }}
                  >
                    View
                  </button>
                </td>
                <td><button className="View_Button">Send Email</button></td>
              </tr>
            ))}
        </tbody>
      </Table>

   
    </div>
  );
}
